import { render } from "./ThePassUpperStandard.vue?vue&type=template&id=74dfc465&scoped=true"
import script from "./ThePassUpperStandard.vue?vue&type=script&lang=js"
export * from "./ThePassUpperStandard.vue?vue&type=script&lang=js"

import "./ThePassUpperStandard.vue?vue&type=style&index=0&id=74dfc465&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74dfc465"

export default script